<div class="container-fluid">
    <div class="row my-2 mb-5">
        <div class="col d-flex justify-content-md-center">
            <h3>Cerca Targa Veicolo</h3>
        </div>
    </div>
    <div class="row my-2">
        <div class="col-4">
            <mat-form-field class="search-plate-input">
                <mat-label>Targa</mat-label>
                <input matInput type="text" placeholder="Targa" [(ngModel)]="plateVal" />
                <button *ngIf="plateVal" matSuffix mat-icon-button aria-label="Clear" (click)="plateVal=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col">
            <button class="btn btn-primary" (click)="onVehicleSearchClick()" [disabled]="plateVal.length === 0">
                Cerca
            </button>
        </div>
    </div>
    <div *ngIf="noVehicleFound" class="row mt-5 mb-2">
        <div class="col d-flex justify-content-md-center">
            <h3 class="search-fail">Nessun veicolo trovato con targa <strong>{{failedValue.toUpperCase()}}</strong></h3>
        </div>
    </div>
    <div *ngIf="foundVehicle !== null" class="row mt-5 mb-2">
        <div class="col d-flex justify-content-md-center">
            <h3 class="search-success">Veicolo trovato <strong>{{foundVehicle.plate}}</strong></h3>
        </div>
    </div>
    <div *ngIf="foundVehicle !== null" class="row my-2">
        <div class="col">
            <strong>Parco</strong>:
            <br>
            {{foundVehicle.park.name}}
            <br>
            ID {{foundVehicle.park.id}}
        </div>
    </div>
    <div *ngIf="foundVehicle !== null" class="row my-2">
        <div class="col">
            <strong>Veicolo</strong>:
            <br>
            {{foundVehicle.model.brand.name}}&nbsp;{{foundVehicle.model.name}}
            <br>
            ID {{foundVehicle.id}}
        </div>
    </div>
</div>